export const GET_ANNUAL_RETURN_FOR_LOBBYIST = "GET_ANNUAL_RETURN_FOR_LOBBYIST"
export const GET_ANNUAL_RETURN = "GET_ANNUAL_RETURN"
export const CLEAR_ANNUAL_RETURNS_FOR_LOBBYIST = "CLEAR_ANNUAL_RETURNS_FOR_LOBBYIST"
export const GET_CHANGES_REQUIRED = "GET_CHANGES_REQUIRED"


// WEBPACK FOOTER //
// ./src/actionTypes/annualReturn.js